export function isZipCode(q) {
  const s = String(q || "").trim();
  return /^\d{5}(-\d{4})?$/.test(s);
}

// Resolves a US address or ZIP to { lat, lng, label } via Nominatim, or null.
export async function geocodeQuery(query) {
  const q = String(query || "").trim();
  if (!q) return null;

  const lower = q.toLowerCase();
  const searchQuery =
    isZipCode(q) || (!lower.includes("usa") && !lower.includes("united states"))
      ? `${q}, USA`
      : q;

  const url = `https://nominatim.openstreetmap.org/search?format=json&limit=1&q=${encodeURIComponent(
    searchQuery
  )}`;

  try {
    const res = await fetch(url, {
      headers: {
        Accept: "application/json",
        "User-Agent": "OccutraceApp/1.0 (contact@occutrace.com)",
      },
    });

    if (!res.ok) {
      console.error("Nominatim response not OK:", res.status, res.statusText);
      return null;
    }

    const data = await res.json();
    if (!Array.isArray(data) || !data.length) return null;

    const top = data[0];
    const lat = Number(top.lat);
    const lng = Number(top.lon);
    if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;

    return {
      lat,
      lng,
      label: isZipCode(q) ? `ZIP ${q.slice(0, 5)}` : top.display_name || q,
    };
  } catch (err) {
    console.error("Geocoding error:", err);
    return null;
  }
}

// True when lat/lng are real coordinates. Empty/null values coerce to 0, and
// 0,0 is the form's placeholder default, so both count as missing.
export function hasCoords(lat, lng) {
  if (lat === "" || lat == null || lng === "" || lng == null) return false;
  const la = Number(lat);
  const ln = Number(lng);
  if (!Number.isFinite(la) || !Number.isFinite(ln)) return false;
  return !(la === 0 && ln === 0);
}
